import { useEffect, useState } from "react";
import { webUrlNode } from "../../../../constants/appInfo";
import EmailTemplatesPanel from "../email/EmailTemplatesPanel";
import EmailTemplatePicker from "../email/EmailTemplatePicker";
export default function RightPanel({ step, steps, onLinkCreated }) {

  const [toId, setToId] = useState("");
  const [type, setType] = useState("BUTTON");
  const [actionKey, setActionKey] = useState("start_trial");
  const [delay, setDelay] = useState(3600);
const [selectedTemplate, setSelectedTemplate] = useState(null);


  if (!step) {
    return <div style={{ width: 320, padding: 12 }}>Select a step</div>;
  }

  async function createLink() {

    const payload = {
      appId:35,
      fromStepId: step.id,
      toStepId: Number(toId),
      actionType: type,
    };

    if (type === "BUTTON") {
      payload.actionKey = actionKey;
    }

    if (type === "DELAY") {
       payload.actionKey = "delay";
      payload.delaySeconds = delay;
    }
 console.log(payload)
    const res = await fetch(`${webUrlNode}/api/funnels/steps/link`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });

    const data = await res.json();

    onLinkCreated(data);
  }

  return (
    <div style={{ overflowY: "auto",overflowX:"hidden",width:"320px",height: "85vh", padding: 12, borderLeft: "1px solid #ddd" }}>
<EmailTemplatesPanel selectedStep={step} />
      <h4>{step.useCase}</h4>
 <EmailTemplatePicker
  value={selectedTemplate?.templateId}
  onChange={setSelectedTemplate}
/>
      <div>
        <label>Target step</label>
        <select value={toId} onChange={e => setToId(e.target.value)}>
          <option value="">Select</option>
          {steps
            .filter(s => s.id !== step.id)
            .map(s => (
              <option key={s.id} value={s.id}>
                {s.useCase}
              </option>
            ))}
        </select>
      </div>

      <div>
        <label>Type</label>
        <select value={type} onChange={e => setType(e.target.value)}>
          <option value="BUTTON">BUTTON</option>
          <option value="DELAY">DELAY</option>
        </select>
      </div>

      {type === "BUTTON" && (
        <div>
          <label>Action key</label>
          <input
            value={actionKey}
            onChange={e => setActionKey(e.target.value)}
            placeholder="start_trial"
          />
        </div>
      )}

      {type === "DELAY" && (
        <div>
          <label>Delay seconds</label>
          <input
            type="number"
            value={delay}
            onChange={e => setDelay(Number(e.target.value))}
          />
        </div>
      )}

      <button onClick={createLink}>
        Create link
      </button>

    </div>
  );
}
